module.exports = __webpack_public_path__ + "static/img/zmbg.c09b19a6.jpg";